import { InfoCircle } from "iconsax-react";

export const InputError = ({ errorTitle, classes }) => {
  return (
    <>
      <div className={`flex items-center text-red text-sm mt-2 ${classes}`}>
        <span>
          <InfoCircle size="16" />
        </span>
        <p className="ml-1">{errorTitle}</p>
      </div>
    </>
  );
};
